/** Secondary tab bar for the OMS pages (Live / History / Reliability /
 *  Unmatched / PowerTRX). Same active-styling idiom as the top Header nav. */
import { Link, useLocation } from 'react-router-dom'
import { appPath, stripAppBase } from '../../appConfig.ts'

const TABS: { to: string; label: string }[] = [
  { to: '/outages', label: 'Live' },
  { to: '/outages/history', label: 'History' },
  { to: '/outages/reliability', label: 'Reliability' },
  { to: '/outages/unmatched', label: 'Unmatched' },
  { to: '/outages/powertrx', label: 'PowerTRX' },
]

export function OmsSubNav() {
  const pathname = stripAppBase(useLocation().pathname)
  return (
    <nav className="flex items-center gap-1 border-b border-gray-200 pb-2">
      {TABS.map(t => {
        const active = pathname === t.to
        return (
          <Link
            key={t.to}
            to={appPath(t.to)}
            className={`text-sm px-3 py-1 rounded transition-colors ${
              active
                ? 'bg-blue-600 text-white'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
            }`}
          >
            {t.label}
          </Link>
        )
      })}
    </nav>
  )
}
